import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import { EmbedUrlIndentifier } from '@/modules/embedurl/constants/EmbedUrlIndentifier';
import { EmbedUrlCollection } from '@/modules/embedurl/models/EmbedUrlCollection';
import EmbedUrlResource from '@/modules/embedurl/resources/EmbedUrlResource';
import { LocaleType } from '@/modules/user/constants/LocaleType';

export class GetEmbedUrlsService extends BaseService {
  resource: typeof EmbedUrlResource;

  constructor() {
    super();

    this.resource = EmbedUrlResource;
  }

  async getEmbedUrls(
    identifiers: EmbedUrlIndentifier[],
    locale?: LocaleType,
    jurisdictionId?: number
  ): Promise<EmbedUrlCollection> {
    return EmbedUrlCollection.mapModel(
      await this.resource.getUrls({ identifiers: identifiers.join(','), locale, jurisdictionId })
    );
  }
}

export default new GetEmbedUrlsService();
